import { EDimensionType } from '@src/common/constant/enum';

export const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const CAN_BE_MAPPED_METADATA_DIMENSION_TYPE = [
  EDimensionType.ORIGINAL,
  EDimensionType.CUSTOM_DIMENSION,
  EDimensionType.EVENT_ATTRIBUTE,
];

export const EQUAL_ONLY_METADATA = ['geo_city', 'geo_country_name', 'geo_region_name'];
